<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                FORM JADWAL SERVICE SARANA
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <input
                            type="hidden"
                            name="_token"
                            v-model="csrfTokens"
                        />
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            v-model="this.services.kodeUnit"
                            @change="selectSarana($event)"
                            required="required"
                        >
                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="Pengemudi">Pengemudi</label>
                        <input
                            type="text"
                            class="form-control"
                            id="driver"
                            v-model="services.driver"
                            placeholder="Pengemudi"
                            step="2"
                            required="required"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmMeter">Kilometer Unit Saat Ini</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometerUnit"
                            v-model="services.kilometerUnit"
                            placeholder="Kilometer Unit"
                            required="required"
                            @keypress="isNumber($event)"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmBerkala">Kilometer Serivce Berkala</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kmBerkala"
                            v-model="services.kilometerBerkala"
                            placeholder="Kilometer Serivce Berkala"
                            required="required"
                            @keypress="isNumber($event)"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmGeneral">Kilometer Serivce General</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kmGeneral"
                            v-model="services.kilometerGeneral"
                            placeholder="Kilometer Serivce General"
                            required="required"
                            @keypress="isNumber($event)"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="catatanService">Catatan Service Saat Ini</label>
                        <textarea
                            type="text"
                            class="form-control"
                            id="catatanService"
                            v-model="services.catatan"
                            placeholder="Catatan Service Saat Ini"
                            rows="5"
                            required="required"
                        ></textarea>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="services.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="tanggal"
                            >Tanggal</label
                        >
                        <input
                            type="date"
                            class="form-control"
                            id="tanggal"
                            v-model="services.tanggal"
                            required="required"
                            readonly="readonly"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="jam">Waktu</label>
                        <input
                            type="time"
                            class="form-control"
                            id="jam"
                            v-model="services.jam"
                            placeholder="Waktu"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="Mekanik">Mekanik</label>
                        <input
                            type="text"
                            class="form-control"
                            id="driver"
                            v-model="services.mekanik"
                            placeholder="Pengemudi"
                            step="2"
                            required="required"
                            readonly="readonly"
                        />
                    </div>



                    <button
                        type="submit"
                        class="btn btn-primary me-3 data-submit"
                    >
                        Submit
                    </button>
                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import moment from "moment"
export default {
    mounted() {

        if (this.username != "")
            this.users = JSON.parse(this.username)
        this.getSarana()
        if(this.idsarana!=null) this.services.kodeUnit=this.idsarana
    },
    data() {
        return {
            moment:moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            services: {},
            sarana: [],
            vehicle : [],
            chkStatus: true,
            idVehicles: null,
            users:{},
            dtime:new Date()
        }
    },
    props: ["tokens", "url_action","username","idsarana"],
    methods: {
        send() {
                 this.save()
        },
        save() {
            axios.post("/sarana/servis", this.services).then((response) => {
                var data = response.data
                if (data.success) {
                    document.location = data.uri
                }
            })
        },
        getSarana() {
            this.initDatas()
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data
                    if (v != null) {
                        var s = {}
                        var vhc = {}
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                    this.changeSarana(this.services.kodeUnit)
                })
        },
        
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault()
            }
            },
        updateData() {
            this.$emit("tabelSaranaEmit")
        },
        focusInputs() {
            this.$refs.kodeUnit.focus()
        },

        chgStatus() {
            this.chkStatus != this.chkStatus
            if (this.chkStatus) {
                this.services.statusService = 1
            } else {
                this.services.statusService = 0
            }
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.services.noLambung = this.sarana[e.target.value]
            this.services.merkType = v
            this.services.kodeUnit = e.target.value
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.services.noLambung = this.sarana[e.target.value]
            this.services.merkType = v
            this.services.kodeUnit = e.target.value
        },
        changeSarana(e){
            var v = this.vehicle[e]
            this.services.noLambung = this.sarana[e]
            this.services.merkType = v
            this.services.kodeUnit = e
            console.log("sarana "+this.services.kodeUnit)

        },

        initDatas() {
            var hari=['Minggu', 'Senin','Selasa','Rabu','Kamis','Jumat','Sabtu']
            var time =this.pad(this.dtime.getHours())+':'+this.pad(this.dtime.getMinutes())+':'+this.pad(this.dtime.getSeconds())
            var dt = moment().format('YYYY-MM-DD')

            this.services = {}
            if (this.url_action != null) {
                this.urlAction = this.url_action
            }
            if (this.tokens != null) {
                this.csrfTokens = this.tokens
            }
            this.services.kodeUnit = ""
            this.services.status = 1
            this.services.tanggal =dt
            this.services.jam = time
            this.services.hari = hari[this.dtime.getDay()]
            this.services.nikMekanik = this.users.username
            this.services.mekanik = this.users.fullName
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString()
        }
    },
    expose: ["initDatas", "getByIds", "focusInputs"],
}
</script>